/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import Cookies from 'js-cookie';
import { HandlerGroupFactoryDeps } from 'src/core/types/handler';
import { LuisConstants } from 'src/core/utils/LuisConstants';

export type ConsentHandlerGroup = ReturnType<typeof createConsentHandlerGroup>;

/**
 * A handler group of consent related operations. Consented users
 * only are allowed to use the website.
 *
 * @param param0 The dependencies for the handler.
 */
export const createConsentHandlerGroup = ({ rootStore, uiStore }: HandlerGroupFactoryDeps) => {
    /**
     * Initializes the consent library.
     */
    const initializeConsent = async ({ rootElement }: { rootElement: HTMLElement }) => {
        // Remove old compliance cookie to ensure no conflict occurs.
        if (Cookies.get(LuisConstants.StorageKeys.ComplianceCookieKey) === 'true') {
            Cookies.remove(LuisConstants.StorageKeys.ComplianceCookieKey);
        }

        WcpConsent.init(
            uiStore.locale.code,
            rootElement,
            (error, siteConsent) => error ?? rootStore.consentStore.setInnerConsentObject(siteConsent),
            newConsentCategories => rootStore.consentStore.setConsentedCategories(newConsentCategories),
            null,
            window.cspNonce
        );
    };

    return { initializeConsent };
};
